module.exports = __webpack_public_path__ + "img/users.fb45642b.svg";